export function isDark (hexColor) {
    // 1. Очищаем строку от знака #, если он есть
    const hex = hexColor.replace('#', '');

    // 2. Переводим HEX в RGB компоненты
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // 3. Рассчитываем перцептивную яркость (формула YIQ)
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    // 4. Если значение меньше 128, цвет считается темным (нужен белый текст)
    // Если 128 и больше — светлым (нужен черный текст)
    return yiq < 128;
}

export function normaliseColor (color) {
    // 1. Если пришел null или undefined, сразу возвращаем undefined
    if (color === null || color === undefined) {
        return null;
    }

    // 2. Если это объект AggregationColor (из Ant Design ColorPicker)
    // Проверяем наличие метода toHexString, чтобы избежать падения
    if (typeof color === 'object' && typeof color.toHexString === 'function') {
        return color.toHexString();
    }

    // 3. Если это уже строка (например, "#f0f0f0")
    if (typeof color === 'string') {
        // Необязательно: можно добавить приведение к нижнему регистру,
        // чтобы цвет всегда был в едином формате (например, "#F0F0F0" -> "#f0f0f0")
        return color.trim() || undefined;
    }

    // На случай, если пришло что-то совсем непредвиденное (число, массив и т.д.)
    return undefined;
}